export default "__VITE_ASSET__CGuQRFKy__"